/**
 * App.js Layout Start Here
 */
import React, { Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { IntlProvider } from 'react-intl';

// CRM layout
import AppSignInToken from './SignInWithToken';
import MainContainer from './MainContainer';
import AppLocale from '../lang';

import { returnDefaultPath } from 'Util/Permissions';

import { Chart as ChartJS, ArcElement, Tooltip, Legend, Title } from 'chart.js';
import RecruitmentJoin from './RecruitmentJoin';
import SignIn from '../routes/sign-in';
import useMainApp from './hooks/useMainApp';
import RctPageLoader from 'Components/RctPageLoader/RctPageLoader';
import { Toaster } from 'react-hot-toast';
import CustomerSupportChat from './CustomerSupportChat';

//for chart
ChartJS.register(ArcElement, Tooltip, Legend, Title);

const App = () => {
  const { user, token, locale, setInitUserInfo, location } = useMainApp();
  if (token && !user) {
    setInitUserInfo();
    return null;
  }
  let defaultPath = returnDefaultPath(user);
  // eslint-disable-next-line no-empty -- 해당 경로는 아래 redirect 분기에서 제외(의도적 fall-through)
  if (location.pathname === '/signin-token' || location.pathname === '/recruitment/join') {
  } else if (token && location.pathname === '/signin') {
    return <Navigate to={defaultPath} />;
  } else if (location.pathname === '/') {
    if (token === null) {
      return <Navigate to='/signin' replace />;
    } else {
      return <Navigate to={defaultPath} />;
    }
  } else if (location.pathname !== '/signin' && token === null) {
    return <Navigate to='/signin' replace />;
  }
  const currentAppLocale = AppLocale[locale.locale];

  return (
    <IntlProvider key={locale.locale} locale={currentAppLocale.locale} messages={currentAppLocale.messages}>
      <Suspense fallback={<RctPageLoader />}>
        <Routes>
          <Route path='/admin/*' element={<MainContainer />} />
          <Route path='/signin' element={<SignIn />} />
          <Route path='/signin/join' element={<SignIn />} />
          <Route path='/signin-token' element={<AppSignInToken />} />
          <Route path='/recruitment/join' element={<RecruitmentJoin />} />
          <Route path='/customer-support-chat' element={<CustomerSupportChat />} />
          <Route path='*' element={<Navigate to='/' replace />} />
        </Routes>
      </Suspense>
      <Toaster
        containerStyle={{
          position: 'fixed',
          top: '60px',
          left: '50%',
          transform: 'translateX(-50%)',
        }}
        gutter={12}
        toastOptions={{
          duration: 3000,
        }}
      />
    </IntlProvider>
  );
};

export default App;
